/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { InvoiceWarningState } from './InvoiceWarningState';
import {
    InvoiceWarningStateFromJSON,
    InvoiceWarningStateFromJSONTyped,
    InvoiceWarningStateToJSON,
    InvoiceWarningStateToJSONTyped,
} from './InvoiceWarningState';

/**
 * 
 * @export
 * @interface InvoiceStatsResponse
 */
export interface InvoiceStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof InvoiceStatsResponse
     */
    paymentTermsDays: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceStatsResponse
     */
    creditAmount: number;
    /**
     * 
     * @type {Currency}
     * @memberof InvoiceStatsResponse
     */
    creditCurrency: Currency;
    /**
     * Unpaid, net of refunds - the figure every customer-facing total on the Invoices screen uses, so the tiles agree with the monthly Total Spend headers.
     * @type {number}
     * @memberof InvoiceStatsResponse
     */
    issuedInvoicesTotal: number;
    /**
     * Unpaid charges with refunds excluded rather than subtracted. This is the figure the credit-limit rule measures (BookingPermittedService uses totalNonRefund), so it is the only one the over-credit-limit banner can quote without contradicting its own title. Everywhere else use issuedInvoicesTotal.
     * @type {number}
     * @memberof InvoiceStatsResponse
     */
    issuedInvoicesChargesTotal: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceStatsResponse
     */
    settlementPendingInvoicesTotal: number;
    /**
     * Unpaid, past due, and NOT disputed - matching the rule that gates booking. A disputed invoice is counted in disputedInvoicesTotal instead.
     * @type {number}
     * @memberof InvoiceStatsResponse
     */
    overdueIssuedInvoicesTotal: number;
    /**
     * Unpaid and disputed. Excluded from overdueIssuedInvoicesTotal.
     * @type {number}
     * @memberof InvoiceStatsResponse
     */
    disputedInvoicesTotal: number;
    /**
     * Whether booking is blocked on this account for any reason at all. Unlike invoiceWarningState, this accounts for reasons we deliberately don't name to the customer, so the screen can stay silent about those without ever claiming that booking works when it doesn't.
     * @type {boolean}
     * @memberof InvoiceStatsResponse
     */
    bookingBlocked: boolean;
    /**
     * 
     * @type {InvoiceWarningState}
     * @memberof InvoiceStatsResponse
     */
    invoiceWarningState: InvoiceWarningState;
}



/**
 * Check if a given object implements the InvoiceStatsResponse interface.
 */
export function instanceOfInvoiceStatsResponse(value: object): value is InvoiceStatsResponse {
    if (!('paymentTermsDays' in value) || value['paymentTermsDays'] === undefined) return false;
    if (!('creditAmount' in value) || value['creditAmount'] === undefined) return false;
    if (!('creditCurrency' in value) || value['creditCurrency'] === undefined) return false;
    if (!('issuedInvoicesTotal' in value) || value['issuedInvoicesTotal'] === undefined) return false;
    if (!('issuedInvoicesChargesTotal' in value) || value['issuedInvoicesChargesTotal'] === undefined) return false;
    if (!('settlementPendingInvoicesTotal' in value) || value['settlementPendingInvoicesTotal'] === undefined) return false;
    if (!('overdueIssuedInvoicesTotal' in value) || value['overdueIssuedInvoicesTotal'] === undefined) return false;
    if (!('disputedInvoicesTotal' in value) || value['disputedInvoicesTotal'] === undefined) return false;
    if (!('bookingBlocked' in value) || value['bookingBlocked'] === undefined) return false;
    if (!('invoiceWarningState' in value) || value['invoiceWarningState'] === undefined) return false;
    return true;
}

export function InvoiceStatsResponseFromJSON(json: any): InvoiceStatsResponse {
    return InvoiceStatsResponseFromJSONTyped(json, false);
}

export function InvoiceStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentTermsDays': json['paymentTermsDays'],
        'creditAmount': json['creditAmount'],
        'creditCurrency': CurrencyFromJSON(json['creditCurrency']),
        'issuedInvoicesTotal': json['issuedInvoicesTotal'],
        'issuedInvoicesChargesTotal': json['issuedInvoicesChargesTotal'],
        'settlementPendingInvoicesTotal': json['settlementPendingInvoicesTotal'],
        'overdueIssuedInvoicesTotal': json['overdueIssuedInvoicesTotal'],
        'disputedInvoicesTotal': json['disputedInvoicesTotal'],
        'bookingBlocked': json['bookingBlocked'],
        'invoiceWarningState': InvoiceWarningStateFromJSON(json['invoiceWarningState']),
    };
}

  export function InvoiceStatsResponseToJSON(json: any): InvoiceStatsResponse {
      return InvoiceStatsResponseToJSONTyped(json, false);
  }

  export function InvoiceStatsResponseToJSONTyped(value?: InvoiceStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentTermsDays': value['paymentTermsDays'],
        'creditAmount': value['creditAmount'],
        'creditCurrency': CurrencyToJSON(value['creditCurrency']),
        'issuedInvoicesTotal': value['issuedInvoicesTotal'],
        'issuedInvoicesChargesTotal': value['issuedInvoicesChargesTotal'],
        'settlementPendingInvoicesTotal': value['settlementPendingInvoicesTotal'],
        'overdueIssuedInvoicesTotal': value['overdueIssuedInvoicesTotal'],
        'disputedInvoicesTotal': value['disputedInvoicesTotal'],
        'bookingBlocked': value['bookingBlocked'],
        'invoiceWarningState': InvoiceWarningStateToJSON(value['invoiceWarningState']),
    };
}

